import { render } from "./PaneResale.vue?vue&type=template&id=86f09c98&scoped=true&ts=true"
import script from "./PaneResale.vue?vue&type=script&lang=ts"
export * from "./PaneResale.vue?vue&type=script&lang=ts"

import "./PaneResale.vue?vue&type=style&index=0&id=86f09c98&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f09c98"]])

export default __exports__